import { assignmentDetailsFetched } from '../mle/mle-actions';
import { enableSpinner, disableSpinner } from '../spinner/spinner-actions';
import Resources from '../../helpers/resources';
import { activateError } from '../error-handling/error-handling-actions';
import { getValueFromUrl } from '../../helpers/utils';
import { ACTIVITY_META_SPINNER } from '../../helpers/constants';

export const ACTIVITY_META_FETCHED = 'ACTIVITY_META_FETCHED';
export const NEXT_ACTIVITY_SET = 'NEXT_ACTIVITY_SET';
export const LOADING_ACTIVITY_STOPPED = 'LOADING_ACTIVITY_STOPPED';
export const LOADING_ACTIVITY_STARTED = 'LOADING_ACTIVITY_STARTED';
export const IS_MARKED_SET = 'IS_MARKED_SET';
export const STUDENT_ANSWER_UPDATED = 'STUDENT_ANSWER_UPDATED';
export const CONQUEST_USER_RESPONSE_REMOVED = 'CONQUEST_USER_RESPONSE_REMOVED';
export const CONQUEST_RESET = 'CONQUEST_RESET';

export const stopLoadingActivity = () => ({
  type: LOADING_ACTIVITY_STOPPED
});

export const startLoadingActivity = () => ({
  type: LOADING_ACTIVITY_STARTED
});

export const setIsMarked = isMarked => ({
  type: IS_MARKED_SET,
  isMarked
});

export const setNextQuestion = ({
  index,
  currentIndex,
  totalQuestions
}) => (dispatch) => {
  let nextIndex = index;

  if (!index) {
    if (currentIndex < totalQuestions - 1) {
      nextIndex = currentIndex + 1;
    } else {
      nextIndex = 0;
    }
  }

  dispatch({
    type: NEXT_ACTIVITY_SET,
    nextIndex
  });
};

export const updateStudentAnswer = payload => ({
  type: STUDENT_ANSWER_UPDATED,
  payload
});

export const removeConquestUserResponse = () => ({
  type: CONQUEST_USER_RESPONSE_REMOVED
});

export const resetConquest = () => ({
  type: CONQUEST_RESET
});

export const fetchActivityMeta = ({
  questionId
}) => async (dispatch) => {
  const assignmentId = getValueFromUrl('assignmentId');
  const locale = getValueFromUrl('locale');
  try {
    const questionResponse = await Resources.fetchActivityMeta
      .get({ assignmentId, questionId, locale })
      .send();

    const { status, data } = questionResponse;

    if (status === 200 || status === 204) {
      dispatch({
        type: ACTIVITY_META_FETCHED,
        data
      });
    }
    return questionResponse;
  } catch (e) {
    dispatch(activateError('network error'));
    return e;
  }
};

export const markActivity = ({
  assignmentId,
  questionId,
  studentAnswer,
  promiseResolved = () => { }
}) => async (dispatch) => {
  dispatch(startLoadingActivity());
  try {
    const questionResponse = await Resources.markActivity
      .put({ assignmentId, questionId })
      .withBody({
        studentAnswer
      })
      .send();

    const { status, data } = questionResponse;

    if (status === 200 || status === 204) {
      dispatch(stopLoadingActivity());
      dispatch(assignmentDetailsFetched(data));
      promiseResolved();
    }
  } catch (e) {
    dispatch(stopLoadingActivity());
    dispatch(activateError('network error'));
  }
};

export const flagActivity = ({
  assignmentId,
  questionId,
  isFlagged
}) => async (dispatch) => {
  try {
    const questionResponse = await Resources.flagActivity
      .put({ assignmentId, questionId })
      .withBody({ isFlagged })
      .send();

    const { status, data } = questionResponse;

    if (status === 200 || status === 204) {
      dispatch(assignmentDetailsFetched(data));
    }
  } catch (e) {
    dispatch(activateError('network error'));
  }
};

export const completeAssignmentQtc = ({
  assignmentId,
  startFetch = () => { },
  endFetch = () => { }
}) => async (dispatch) => {
  const locale = getValueFromUrl('locale');
  startFetch();
  try {
    const questionResponse = await Resources.completeAssignmentQtc
      .put({ assignmentId, locale })
      .withBody({})
      .send();

    const { status, data } = questionResponse;

    if (status === 200 || status === 204) {
      dispatch(assignmentDetailsFetched(data));
      dispatch(setNextQuestion({ index: 0 }));
    }
    endFetch();
  } catch (e) {
    dispatch(activateError('network error'));
    endFetch();
  }
};

export const handleSpinner = ({ isLoading, loadedInitialActivity }) => (dispatch) => {
  if (!loadedInitialActivity) {
    if (isLoading) {
      dispatch(enableSpinner(ACTIVITY_META_SPINNER));
    } else if (!isLoading) {
      dispatch(disableSpinner(ACTIVITY_META_SPINNER));
    }
  }
};
